import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('product-item', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./product-item')
    ),
);
